module.exports = __webpack_public_path__ + "img/sidebar_ic_location.182d74b7.svg";